import React from 'react';
import { useParams } from 'react-router-dom';

import Countries from './Countries';

const CountriesModalRoute: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const mode = id ? 'edit' : 'create';

  return (
    <Countries
      initialModal={{ mode, countryId: id }}
      modalReturnTo="/countries"
    />
  );
};

export default CountriesModalRoute;
